import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import './lead-quality.css';

// Shared Study Abroad WhatsApp/phone field. All DOM + styles are isolated
// inside .lqe-phone-field — zero impact on surrounding page layout.
export const LeadPhoneField = ({
  engine,
  variant = 'sa',
  label = 'WhatsApp Number *',
  helper = 'Our counsellor will share your profile evaluation.',
  showLabel = true,
  testId = 'lqe-phone-input',
}) => (
  <div className={`lqe-phone-field lqe-${variant}`} data-testid={`${testId}-field`}>
    {showLabel && <label className="lqe-phone-label">{label}</label>}
    <PhoneInput
      defaultCountry="in"
      value={engine.phone}
      onChange={engine.handlePhoneChange}
      inputProps={{
        'data-testid': testId,
        name: 'phone',
        'aria-label': label,
        autoComplete: 'tel',
      }}
    />
    {!engine.phoneError && helper && <p className="lqe-phone-helper">{helper}</p>}
    {engine.phoneError && (
      <p className="lqe-phone-error" role="alert" data-testid={`${testId}-error`}>
        {engine.phoneError}
      </p>
    )}
    <input
      type="text"
      name="website"
      value={engine.honeypot}
      onChange={(e) => engine.setHoneypot(e.target.value)}
      className="lqe-hp-field"
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      data-testid={`${testId}-honeypot`}
    />
  </div>
);
